/* eslint-disable max-classes-per-file */
import { RaskColumn } from "~app/common/components/table/models/rask-column";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";

export class ArbetsorderTradslagsdataViewModel {
    hasTradslagsdataBeraknatUttag: boolean;
    byl: string;
    hektar: string;
    uttagm3fub: string;
    tradslagsdata: TradslagsdataRowViewModel[];
    tradslagsdataBeraknatUttag: TradslagsdataRowViewModel[];

    tradslagsdataColumns = [
        {
            headerName: "Trädslag",
            field: "namn",
            type: "span",
            width: 80,
            footerText: "S:a/med"
        },
        {
            headerName: "m3sk/ha",
            field: "volymM3skHa",
            type: "span",
            width: 82,
            footerAgg: () => this.tradslagsdataSummary?.volymM3skHa?.toFixed(0)
        },
        {
            headerName: "GY",
            field: "grundyta",
            type: "span",
            width: 55,
            footerAgg: () => this.tradslagsdataSummary?.grundyta?.toFixed(1)
        },
        {
            headerName: "DGV",
            field: "diameterGrundytevagd",
            type: "span",
            width: 57,
            footerAgg: () => this.tradslagsdataSummary?.diameterGrundytevagd?.toFixed(1)
        },
        {
            headerName: "HGV",
            field: "hojdGrundytevagd",
            type: "span",
            width: 57,
            footerAgg: () => this.tradslagsdataSummary?.hojdGrundytevagd?.toFixed(1)
        },
        {
            headerName: "st/ha",
            field: "stammarPerHa",
            type: "span",
            width: 60,
            footerAgg: () => this.tradslagsdataSummary?.stammarPerHa?.toFixed(0)
        },
        {
            headerName: "mstam",
            field: "medelstam",
            type: "span",
            width: 70,
            footerAgg: () => this.tradslagsdataSummary?.medelstam?.toFixed(2)
        },
        {
            headerName: "Diaförd",
            field: "diameterfordelningTyp",
            type: "span",
            width: 80
        }
    ] as RaskColumn[];

    tradslagsdataBeraknatUttagColumns = [
        {
            headerName: "Trädslag",
            field: "namn",
            type: "span",
            width: 80,
            footerText: "S:a/med"
        },
        {
            headerName: "m3sk/ha",
            field: "volymM3skHa",
            type: "span",
            width: 82,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.volymM3skHa?.toFixed(0)
        },
        {
            headerName: "GY",
            field: "grundyta",
            type: "span",
            width: 55,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.grundyta?.toFixed(1)
        },
        {
            headerName: "DGV",
            field: "diameterGrundytevagd",
            type: "span",
            width: 57,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.diameterGrundytevagd?.toFixed(1)
        },
        {
            headerName: "HGV",
            field: "hojdGrundytevagd",
            type: "span",
            width: 57,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.hojdGrundytevagd?.toFixed(1)
        },
        {
            headerName: "st/ha",
            field: "stammarPerHa",
            type: "span",
            width: 60,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.stammarPerHa?.toFixed(0)
        },
        {
            headerName: "mstam",
            field: "medelstam",
            type: "span",
            width: 70,
            footerAgg: () => this.tradslagsdataSummaryBeraknatUttag?.medelstam?.toFixed(2)
        },
        {
            headerName: "Diaförd",
            field: "diameterfordelningTyp",
            type: "span",
            width: 80
        }
    ] as RaskColumn[];

    private readonly tradslagsdataSummary: ITradslagsdataRow;
    private readonly tradslagsdataSummaryBeraknatUttag: ITradslagsdataRow;
    private readonly hasAtgard: boolean;

    constructor(readonly arbetsorder: IArbetsorderDetail, readonly atgard: IAtgard, tradslagsdataResponse?: ITradslagsdataResponse) {
        this.hasAtgard = !ObjectUtils.isNullOrUndefined(this.atgard);
        this.hasTradslagsdataBeraknatUttag = tradslagsdataResponse?.tradslagsdataBeraknatUttag.length > 0;
        this.byl = this.hasAtgard ? this.atgard.byl : this.arbetsorder.gyl;
        this.hektar = this.hasAtgard ? this.atgard.hektar.toFixed(2) : this.arbetsorder.hektar.toFixed(2);

        this.tradslagsdata = tradslagsdataResponse?.tradslagsdata.map(x => new TradslagsdataRowViewModel(x));
        this.tradslagsdataSummary = tradslagsdataResponse?.tradslagsdataSummary;
        this.tradslagsdataBeraknatUttag = tradslagsdataResponse?.tradslagsdataBeraknatUttag.map(x => new TradslagsdataRowViewModel(x));
        this.tradslagsdataSummaryBeraknatUttag = tradslagsdataResponse?.tradslagsdataSummaryBeraknatUttag;
        this.setUttagm3fub();
    }

    private setUttagm3fub(): void {
        if (!this.tradslagsdataSummaryBeraknatUttag?.stammarPerHa
            || !this.tradslagsdataSummaryBeraknatUttag?.medelstam) {
            return;
        }

        if (this.hasAtgard) {
            this.uttagm3fub = (this.tradslagsdataSummaryBeraknatUttag.stammarPerHa
                * this.tradslagsdataSummaryBeraknatUttag.medelstam * this.atgard.hektar).toFixed(0);
        } else {
            this.uttagm3fub = (this.tradslagsdataSummaryBeraknatUttag.stammarPerHa
                * this.tradslagsdataSummaryBeraknatUttag.medelstam * this.arbetsorder.hektar).toFixed(0);
        }
    }
}

export class TradslagsdataRowViewModel {
    namn?: string;
    volymM3skHa?: string;
    grundyta?: string;
    diameterGrundytevagd?: string;
    hojdGrundytevagd?: string;
    stammarPerHa?: string;
    medelstam?: string;
    diameterfordelningTyp: string;

    constructor(source: ITradslagsdataRow) {
        this.namn = source.tradslag?.namn;
        this.volymM3skHa = source.volymM3skHa?.toFixed(0);
        this.grundyta = source.grundyta?.toFixed(1);
        this.diameterGrundytevagd = source.diameterGrundytevagd?.toFixed(1);
        this.hojdGrundytevagd = source.hojdGrundytevagd?.toFixed(1);
        this.stammarPerHa = source.stammarPerHa?.toFixed(0);
        this.medelstam = source.medelstam?.toFixed(2);

        this.diameterfordelningTyp = source.diameterfordelningTyp ?? "-";
    }
}

export interface ITradslagsdataResponse {
    tradslagsdata: ITradslagsdataRow[];
    tradslagsdataSummary: ITradslagsdataRow;
    tradslagsdataBeraknatUttag: ITradslagsdataRow[];
    tradslagsdataSummaryBeraknatUttag: ITradslagsdataRow;
}

export interface ITradslagsdataRow {
    tradslag?: ITradslag;
    volymM3skHa?: number;
    grundyta?: number;
    diameterGrundytevagd?: number;
    hojdGrundytevagd?: number;
    stammarPerHa?: number;
    medelstam?: number;
    rundvirkesvolymTotal?: number;
    antalStammarTotal?: number;
    diameterfordelningTyp: string;
}

export interface ITradslag {
    namn: string;
}
